import { FeatureAvailability, TicketFeature } from 'apollo/types';

const byAvailability = (
  features: TicketFeature[] | null | undefined,
  availability: FeatureAvailability
): TicketFeature[] =>
  [...(features ?? [])]
    .filter((feature) => feature.availability === availability)
    .sort((a, b) => a.position - b.position);

const getIncludedFeatures = (features?: TicketFeature[] | null): TicketFeature[] =>
  byAvailability(features, FeatureAvailability.Included);

export const getExcludedFeatures = (features?: TicketFeature[] | null): TicketFeature[] =>
  byAvailability(features, FeatureAvailability.NotIncluded);

export const getAvailabilityFeatures = (
  features?: TicketFeature[] | null
): TicketFeature[] =>
  byAvailability(features, FeatureAvailability.AccordingToAvailability);

export const getOfferedFeatures = (
  features?: TicketFeature[] | null
): TicketFeature[] => [
  ...getIncludedFeatures(features),
  ...getAvailabilityFeatures(features),
];

export default getIncludedFeatures;
